import template from './message.html'

const messageComponent = () => {
    return {
        async init() {
            this.$nextTick(() => {
                this.$el.innerHTML = template
            })
        },
        remove(message){
            this.$store.message.remove(message)
        }
    }
}

export { messageComponent }
